import React, { ReactNode } from "react";
import { Button, Card, Grid, Typography } from "@material-ui/core";
import { ewbConfig } from "config";
import useWindowResizeListener from "hooks/useWindowResizeListener";
import "./FeaturedProducts.css";

const Item = ({
  field_feature_image,
  title,
  field_blurb,
  field_link_url,
  field_link_type,
  idx,
  navigateToPage,
}): ReactNode => {
  const { isMobile } = useWindowResizeListener();
  return (
    <Grid
      className="center"
      style={{ padding: 25 }}
      item
      lg={4}
      md={4}
      xs={12}
      sm={12}
      key={idx}
    >
      <Card
        className="item background-color-white"
        style={{
          backgroundImage: `url(${
            ewbConfig.appDomain + field_feature_image.replace(/\\\//g, "/")
          })`,
        }}
      >
        <div className="empty-space" />
        <div className="card-text-container">
          <div style={{ flex: 0.25 }}>
            <Typography
              color="primary"
              dangerouslySetInnerHTML={{ __html: title }}
              style={{ fontWeight: "600", fontSize: 20 }}
            />
          </div>
          <div style={{ flex: 0.45 }}>
            <div
              className="field-blurb"
              dangerouslySetInnerHTML={{ __html: field_blurb }}
            />
          </div>
          <div
            style={{
              flex: 0.3,
              alignItems: "flex-end",
            }}
          >
            <Button
              variant="contained"
              fullWidth={isMobile}
              color="secondary"
              size="medium"
              onClick={navigateToPage(field_link_type, field_link_url)}
            >
              READ MORE
            </Button>
          </div>
        </div>
      </Card>
    </Grid>
  );
};

export default Item;
